<template lang="pug">
div
  card-financeiro(
    cardTitle="Cadastrar processo físico"
  )
    template(slot="body")
      validation-observer(ref='observer', tag='form', v-slot="{ invalid }")
        el-tabs(v-model="isActive" @tab-click="handleClick")
          el-tab-pane(label="Geral" name="geral")
            div(v-if="isActive === 'geral'")
              el-row.margin-bottom-20(type="flex", :gutter="40", style="margin-top: 30px")
                el-col(:lg="12")
                  validation-provider(rules="required|max:50", v-slot="{ errors }", name="número processo")
                    app-label(label="Número do processo:", :required="true")
                    div(slot="footer", class="dialog-footer")
                      el-input.input(
                        v-model="processoFisico.numero",
                        @change="findProcessoAndCompleteForms",
                        maxlength="50",
                        placeholder='0000/000000'
                        :class="{'erro' : errors.length}"
                      )
                        el-button(slot="append", icon="el-icon-search")
                      span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="tipo de processo")
                    app-label(label="Tipo de processo:", :required="true")
                    el-select.select.input(
                      v-model="processoFisico.tipoCadastro.id",
                      placeholder="Selecione",
                      filterable,
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in tipoProcessosFiltrados"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id"
                      )
                    span.help.erro {{ errors[0] }}

          el-tab-pane(label="Cadastrante" name="cadastrante" :disabled="tabsDisabled()")
            div(v-if="isActive === 'cadastrante'")
              el-row.margin-bottom-20(type="flex", :gutter="40", style="margin-top: 30px")
                el-col(:lg="12")
                  validation-provider(rules="cpf_cnpj", v-slot="{ errors }", name="CPF/CNPJ do cadastrante")
                    app-label(label="CPF/CNPJ do cadastrante:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.cpfCnpj",
                      v-mask="['###.###.###-##', '##.###.###/####-##']",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="nome/razão social do cadastrante")
                    app-label(label="Nome/Razão social do cadastrante:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.nomeRazaoSocial",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  app-input-telefone(
                    :telefones="processoFisico.cadastrante.telefone",
                    nomeAba="cadastrante",
                    :observer="$refs.observer",
                    :requiredTelefones="true"
                  )
                el-col(:lg="12")
                  app-input-email(
                    :emails="processoFisico.cadastrante.email",
                    nomeAba="cadastrante",
                    :observer="$refs.observer",
                    :requiredEmails="true"
                  )
              app-divider.margin-bottom-20(label="Endereço")
              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="logradouro do cadastrante")
                    app-label(label="Logradouro:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.endereco.logradouro",
                      show-word-limit,
                      maxlength="100",
                      :disabled="true",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="número do cadastrante")
                    app-label(label="Número:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.endereco.numero",
                      :disabled="processoFisico.cadastrante.endereco.semNumero || inputDisabled"
                      type="number"
                      :class="{'erro' : errors.length}"
                    )
                      el-checkbox.input(
                        v-model="processoFisico.cadastrante.endereco.semNumero",
                        label="S/N", slot="prepend",
                        :disabled="true"
                        @change="onSemNumeroCadastranteCheck"
                      )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  app-label(label="Complemento:", :required="false")
                  el-input.input(v-model="processoFisico.cadastrante.endereco.complemento", :disabled="true")

                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="bairro do cadastrante")
                    app-label(label="Bairro:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.endereco.bairro",
                      :disabled="true"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="CEP do cadastrante")
                    app-label(label="CEP:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cadastrante.endereco.cep",
                      v-mask="'#####-###'",
                      :disabled="true"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="UF do cadastrante")
                    app-label(label="UF:", :required="true")
                    el-select.select.input(
                      v-model="processoFisico.cadastrante.endereco.uf",
                      :disabled="true"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                    el-col(:lg="12")

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="município do cadastrante")
                    app-label(label="Município:", :required="true")
                    el-select.select.input(
                      v-model="processoFisico.cadastrante.endereco.municipio.id",
                      placeholder="Selecione",
                      :filterable="true",
                      :disabled="true",
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in municipiosInteressado"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id"
                      )
                    span.help.erro {{ errors[0] }}

          el-tab-pane(label="Interessado" name="interessado", :disabled="tabsDisabled()" style="margin-top: 30px")
            div(v-if="isActive === 'interessado'")
              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  validation-provider(rules="cpf_cnpj", v-slot="{ errors }", name="CPF/CNPJ do interessado")
                    app-label(label="CPF/CNPJ do interessado:", :required="true")
                    el-input.input(
                      v-model="processoFisico.cpfCnpjInteressado",
                      v-mask="['###.###.###-##', '##.###.###/####-##']",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="nome/razão social do interessado")
                    app-label(label="Nome/Razão social do interessado:", :required="true")
                    el-input.input(
                      v-model="processoFisico.nomeRazaoSocialInteressado",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  app-input-telefone(
                    :telefones="processoFisico.telefone",
                    nomeAba="interessado",
                    :observer="$refs.observer",
                    :requiredTelefones="true"
                  )
                el-col(:lg="12")
                  app-input-email(
                    :emails="processoFisico.email",
                    nomeAba="interessado",
                    :observer="$refs.observer",
                    :requiredEmails="true"
                  )
              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Estado civil")
                    app-label(label="Estado civil:", :required="true")
                    el-select.input(
                      class="select",
                      name='Estado civil'
                      v-model="processoFisico.estadoCivilInteressado",
                      @change="clearConjuge"
                      value-key="codigo"
                      no-match-text="Nenhum estado civil encontrado",
                      placeholder="Selecione",
                      clearable,
                      filterable,
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in estadosCivil",
                        :key="item.codigo",
                        :label="item.nome",
                        :value="item.codigo"
                      )
                    span.help.erro {{ errors[0] }}

              app-divider.margin-bottom-20(label="Cônjuge" v-if="isViuvo || estadoCivilGeral")
              el-row.labelDiv.margin-bottom-20(:gutter="30" v-if="isViuvo || estadoCivilGeral")
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required|cpf", v-slot="{ errors }", name="Conjuge - CPF")
                    app-label(label="CPF:")
                    el-input.input(
                      name='CPF',
                      v-model="processoFisico.conjuge.cpf",
                      v-mask="'###.###.###-##'",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Conjuge - Nome")
                    app-label(label="Nome:")
                    el-input.input(
                      name='Nome',
                      v-model="processoFisico.conjuge.nome",
                      maxlength="300"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col.inputDiv(:span="8")
                  app-label(label="Apelido:" :required="false")
                  el-input.input(
                    name='Apelido',
                    v-model="processoFisico.conjuge.apelido",
                    maxlength="300"
                  )
              el-row.labelDiv.margin-bottom-20(:gutter="30" v-if="estadoCivilGeral")
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Conjuge - RG")
                    app-label(label="RG:")
                    el-input.input(
                      name='RG',
                      maxlength="30"
                      v-model="processoFisico.conjuge.rg",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Conjuge - Órgão Expedidor")
                    app-label(label="Órgão expedidor:")
                    el-select.input(
                      name='Órgão expedidor'
                      class="select",
                      no-match-text="Nenhum orgão encontrado",
                      placeholder="Selecione",
                      v-model="processoFisico.conjuge.orgaoExpedidor.codigo"
                      @change="setOrgaoCodigo"
                      value-key="id"
                      filterable,
                      clearable,
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="orgaoExpedidor in orgaosExpedidores",
                        :key="orgaoExpedidor.codigo",
                        :label="orgaoExpedidor.nome",
                        :value="orgaoExpedidor.codigo"
                      )
                    span.help.erro {{ errors[0] }}

                el-col.inputDiv(:span="8")
                  app-label(label="UF do RG:" :required="false")
                  el-select.input(
                    name='UF do RG'
                    class="select",
                    no-match-text="Nenhuma UF encontrada",
                    placeholder="Selecione",
                    v-model="processoFisico.conjuge.orgaoExpedidor.estado"
                    @change="setOrgaoNomeEstado"
                    clearable,
                    filterable,
                    :disabled="!processoFisico.conjuge.orgaoExpedidor.codigo"
                  )
                    el-option(
                      v-for="estado in estadosBr",
                      :key="estado.codigo",
                      :label="estado.nome",
                      :value="estado.codigo"
                    )

              el-row.labelDiv.margin-bottom-20(:gutter="30" v-if="estadoCivilGeral")
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Conjuge - Nacionalidade")
                    app-label(label="Nacionalidade:")
                    el-select.input(
                      name='Nacionalidade'
                      class="select",
                      no-match-text="Nenhuma nacionalidade encontrada",
                      placeholder="Selecione",
                      v-model="processoFisico.conjuge.nacionalidade"
                      value-key="id"
                      clearable,
                      filterable,
                      @change='changeNacionalidade',
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in gentilico",
                        :key="item.id",
                        :label="item.gentilico",
                        :value="item.sigla",
                      )
                    span.help.erro {{ errors[0] }}
                el-col.inputDiv(:span="8")
                  validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", name="Conjuge - UF de Naturalidade")
                    app-label(label="UF de naturalidade:", :required="isBrasileiro")
                    el-select.input(
                      class="select",
                      no-match-text="Nenhuma UF encontrada",
                      placeholder="Selecione",
                      v-model="processoFisico.conjuge.ufNaturalidade",
                      clearable,
                      @change='setMunicipioNaturalidade',
                      filterable,
                      :disabled="!isBrasileiro",
                      name="UF de Naturalidade",
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in estadosBr",
                        :key="item.codigo",
                        :label="item.nome",
                        :value="item.codigo"
                      )
                    span.help.erro {{ errors[0] }}

                el-col.inputDiv(:span="8")
                  validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", name="Conjuge - Município de Naturalidade")
                    app-label(label="Município de naturalidade:", :required="isBrasileiro")
                    el-select.input(
                      class="select",
                      name='Município de Naturalidade'
                      no-match-text="Nenhum município encontrado",
                      placeholder="Selecione",
                      v-model="processoFisico.conjuge.municipioNaturalidade.id",
                      filterable,
                      :disabled="!isBrasileiro",
                      :class="{'erro' : errors.length}",
                      value-key="id"
                    )
                      el-option(
                        v-for="item in municipiosConjuge",
                        :key="item.id",
                        :label="item.nome",
                        :value="item.id"
                      )
              el-row.margin-bottom-20(:gutter="30" v-if="isViuvo || estadoCivilGeral")
                el-col.inputDiv(:span="8")
                  validation-provider(rules="required", v-slot="{ errors }", name="Conjuge - Data de nascimento")
                    app-label(label="Data de nascimento:", :required = "true")
                    el-date-picker.input.full-width(
                      type="date",
                      name='Data de nascimento'
                      v-model="processoFisico.conjuge.dataNascimento",
                      v-mask="'##/##/#####'",
                      placeholder="Selecione",
                      format="dd/MM/yyyy",
                      :picker-options="pickerOptions",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
              app-divider.margin-bottom-20(label="Endereço")
              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="logradouro")
                    app-label(label="Logradouro:", :required="true")
                    el-input.input(
                      v-model="processoFisico.endereco.logradouro",
                      show-word-limit,
                      maxlength="100",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="número")
                    app-label(label="Número:", :required="true")
                    el-input.input(
                      v-model="processoFisico.endereco.numero",
                      :disabled="processoFisico.endereco.semNumero || inputDisabled"
                      type="number"
                      :class="{'erro' : errors.length}"
                    )
                      el-checkbox.input(
                        v-model="processoFisico.endereco.semNumero",
                        label="S/N", slot="prepend",
                        :disabled="inputDisabled"
                        @change="onSemNumeroCheck"
                      )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  app-label(label="Complemento:", :required="false")
                  el-input.input(v-model="processoFisico.endereco.complemento", :disabled="inputDisabled")

                el-col(:lg="12")
                  validation-provider(rules="required|max:100", v-slot="{ errors }", name="bairro")
                    app-label(label="Bairro:", :required="true")
                    el-input.input(
                      v-model="processoFisico.endereco.bairro",
                      :disabled="inputDisabled"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

              el-row.margin-bottom-20(type="flex", :gutter="40")
                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="CEP")
                    app-label(label="CEP:", :required="true")
                    el-input.input(
                      v-model="processoFisico.endereco.cep",
                      v-mask="'#####-###'",
                      :disabled="inputDisabled"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="UF")
                    app-label(label="UF:", :required="true")
                    el-select.select.input(
                      v-model="processoFisico.endereco.uf",
                      :disabled="true"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}

                el-col(:lg="12")
                  validation-provider(rules="required", v-slot="{ errors }", name="município")
                    app-label(label="Município:", :required="true")
                    el-select.select.input(
                      v-model="processoFisico.endereco.municipio.id",
                      placeholder="Selecione",
                      :filterable="true",
                      :disabled="inputDisabled",
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for="item in municipiosInteressado"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id"
                      )
                    span.help.erro {{ errors[0] }}

  app-buttons-cadastro(
    :isPrimeiroPasso="isPrimeiroPasso()",
    :isUltimoPasso="isUltimoPasso()",
    :showButtonSalvar="showButtonSalvar()",
    :disabledButtonProximo="tabsDisabled()"
    :showButtonProximo="true"
    :showButtonVoltar="true"
    :isProcessoFisico="true",
    @cancelar="cancelar",
    @finalizar="validateAndSaveOnFinalizar"
    @proximo="proximo"
    @voltar="voltar"
    @salvar="salvar"
  )

</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CardFinanceiro from '../../components/CardFinanceiro'
import AppDivider from '@/components/AppDivider'
import _ from 'lodash'
import estadosBr from '@/constants/estados'
import gentilico from '@/constants/gentilico'
import AppInputTelefone from '@/components/AppInputTelefone'
import AppInputEmail from '@/components/AppInputEmail.vue'
const { estadosCivil } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppLabel,
    AppButtonsCadastro,
    CardFinanceiro,
    AppDivider,
    AppInputTelefone,
    AppInputEmail
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      isPa: process.env.ESTADO === 'pa',
      estadosCivil,
      orgaosExpedidores: [],
      municipiosInteressado: [],
      municipiosConjuge: [],
      estadosBr,
      gentilico,
      dadosCadastrante: false,
      isActive: 'geral',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      processoFisico: {
        numero: null,
        tipoCadastro: {
          id: null
        },
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: '',
        estadoCivilInteressado: null,
        telefone: [],
        email: [],
        isFinalizado: false,
        endereco: {
          logradouro: null,
          numero: null,
          semNumero: false,
          bairro: null,
          complemento: null,
          cep: null,
          municipio: {
            id: null
          },
          uf: this.findEstado()
        },
        cadastrante: {
          nomeRazaoSocial: null,
          cpfCnpj: null,
          telefone: [],
          email: [],
          endereco: {
            logradouro: null,
            numero: null,
            semNumero: false,
            bairro: null,
            complemento: null,
            cep: null,
            municipio: {
              id: null
            },
            uf: this.findEstado()
          }
        },
        conjuge: {
          cpf: null,
          nome: null,
          apelido: null,
          rg: null,
          orgaoExpedidor: {
            id: '',
            codigo: '',
            nome: '',
            estado: '',
            nomeEstado: ''
          },
          nacionalidade: null,
          ufNaturalidade: null,
          municipioNaturalidade: {
            codigoEstado: '',
            id: '',
            nome: ''
          },
          dataNascimento: null
        }
      },
      inputDisabled: true
    }
  },

  async created () {
    this.processoFisico.numero = null
    this.getTiposProcessos()
    this.municipiosInteressado = await this.getMunicipiosByEstadoAtual()
    if (this.$route.params.numeroProcesso) {
      this.findProcessoAndCompleteForms(this.$route.params.numeroProcesso)
    }
  },

  mounted () {
    this.estadosCivil.forEach(element => {
      element.nome = element.nome.toUpperCase()
    })
    this.setOrgaosExpeditores()
  },

  computed: {
    ...mapState({
      tiposProcessos: state => state.processos.tiposProcessos,
      municipiosPA: state => state.municipios.municipiosPA
    }),

    tipoProcessosFiltrados () {
      const tiposProcessosExcluidos = ['GENERICO']
      let tiposProcessosFiltrados = this.tiposProcessos.filter(tipoProcesso => !tiposProcessosExcluidos.includes(tipoProcesso.codigo))
      return tiposProcessosFiltrados
    },

    isBrasileiro () {
      return this.processoFisico.conjuge.nacionalidade && this.processoFisico.conjuge.nacionalidade === 'BR'
    },

    isViuvo () {
      return this.processoFisico.estadoCivilInteressado && this.processoFisico.estadoCivilInteressado === 'VIUVO'
    },

    estadoCivilGeral () {
      let outros = ['CASADO', 'UNIAO_ESTAVEL', 'UNIAO_HOMOAFETIVA']
      return this.processoFisico.estadoCivilInteressado && outros.includes(this.processoFisico.estadoCivilInteressado)
    }
  },

  methods: {
    ...mapActions({
      salvarProcessoFisico: 'cadastroProcessoFisico/save',
      getTiposProcessos: 'processos/getTiposProcessos',
      getMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      findProcessoByNumeroProcesso: 'cadastroProcessoFisico/findProcessoByNumeroProcesso',
      findEnderecoById: 'endereco/findEnderecoIterpa',
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    clearProcessoFisico () {
      return {
        numero: null,
        tipoCadastro: {
          id: null
        },
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: '',
        estadoCivilInteressado: null,
        telefone: [],
        email: [],
        isFinalizado: false,
        endereco: {
          logradouro: null,
          numero: null,
          semNumero: false,
          bairro: null,
          complemento: null,
          cep: null,
          municipio: {
            id: null
          },
          uf: this.findEstado()
        },
        cadastrante: {
          nomeRazaoSocial: null,
          cpfCnpj: null,
          telefone: [],
          email: [],
          endereco: {
            logradouro: null,
            numero: null,
            semNumero: false,
            bairro: null,
            complemento: null,
            cep: null,
            municipio: {
              id: null
            },
            uf: this.findEstado()
          }
        },
        conjuge: {
          cpf: null,
          nome: null,
          apelido: null,
          rg: null,
          orgaoExpedidor: {
            id: '',
            codigo: '',
            nome: '',
            estado: '',
            nomeEstado: ''
          },
          nacionalidade: null,
          ufNaturalidade: null,
          municipioNaturalidade: {
            codigoEstado: '',
            id: '',
            nome: ''
          },
          dataNascimento: null
        }
      }
    },

    clearConjuge () {
      this.processoFisico.conjuge = {
        cpf: null,
        nome: null,
        apelido: null,
        rg: null,
        orgaoExpedidor: {
          id: '',
          codigo: '',
          nome: '',
          estado: '',
          nomeEstado: ''
        },
        nacionalidade: null,
        ufNaturalidade: null,
        municipioNaturalidade: {
          codigoEstado: '',
          id: '',
          nome: ''
        },
        dataNascimento: null
      }
    },

    changeNacionalidade () {
      this.processoFisico.conjuge.ufNaturalidade = null
      this.clearMunicipioNaturalidade()
    },

    async setMunicipioNaturalidade (sigla) {
      this.clearMunicipioNaturalidade()
      this.municipiosConjuge = await this.getMunicipiosByUf(sigla)
    },

    clearMunicipioNaturalidade () {
      this.processoFisico.conjuge.municipioNaturalidade = {
        codigoEstado: '',
        id: '',
        nome: ''
      }
    },

    ufAndMunicipioRequired () {
      return this.processoFisico.conjuge.nacionalidade === 'BR' ? 'required' : ''
    },

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
    },

    setOrgaoCodigo () {
      if (!this.processoFisico.conjuge.orgaoExpedidor.codigo) {
        this.processoFisico.conjuge.orgaoExpedidor = {
          id: '',
          codigo: '',
          nome: '',
          estado: '',
          nomeEstado: ''
        }
        return
      }
      const orgao = this.orgaosExpedidores.find(
        orgao => orgao.codigo === this.processoFisico.conjuge.orgaoExpedidor.codigo
      )
      this.processoFisico.conjuge.orgaoExpedidor.codigo = orgao.codigo
      this.processoFisico.conjuge.orgaoExpedidor.nome = orgao.nome
    },

    setOrgaoNomeEstado () {
      if (!this.processoFisico.conjuge.orgaoExpedidor.estado) {
        this.processoFisico.conjuge.orgaoExpedidor.nomeEstado = null
        return
      }
      this.processoFisico.conjuge.orgaoExpedidor.nomeEstado = this.estadosBr.find(
        estado => estado.codigo === this.processoFisico.conjuge.orgaoExpedidor.estado
      ).nome
    },

    async carregarEnderecoIterpa () {
      try {
        const resp = await this.findEnderecoById(0)
        this.processoFisico.cadastrante.endereco.logradouro = resp.logradouro
        this.processoFisico.cadastrante.endereco.numero = resp.numero
        this.processoFisico.cadastrante.endereco.bairro = resp.bairro
        this.processoFisico.cadastrante.endereco.complemento = resp.complemento
        this.processoFisico.cadastrante.endereco.cep = resp.cep
        this.processoFisico.cadastrante.endereco.municipio.id = resp.municipio.id || {id: null}
        this.processoFisico.cadastrante.endereco.uf = resp.uf
        this.processoFisico.cadastrante.endereco.semNumero = resp.semNumero
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          'Erro ao buscar endereço do iterpa'
        )
      }
    },

    handleClick (tab) {
      this.isActive = tab.name
    },

    isUltimoPasso () {
      return this.isActive === 'interessado'
    },

    isPrimeiroPasso () {
      return this.isActive === 'geral'
    },

    showButtonSalvar () {
      return !this.isPrimeiroPasso()
    },

    findEstado () {
      return process.env.ESTADO.toUpperCase()
    },

    tabsDisabled () {
      return !this.processoFisico.numero || !this.processoFisico.tipoCadastro.id
    },

    async findProcessoAndCompleteForms (numeroProcesso) {
      const processo = await this.findProcessoByNumeroProcesso(numeroProcesso)
      this.completeForms(processo, numeroProcesso)
      this.inputDisabled = false
      this.formataProcesso()
      if (this.processoFisico.conjuge.ufNaturalidade) {
        this.municipiosConjuge = await this.getMunicipiosByUf(this.processoFisico.conjuge.ufNaturalidade)
      }
    },

    completeForms (processo, numeroProcesso) {
      if (processo !== null) {
        this.processoFisico = processo
        this.processoFisico.numero = numeroProcesso
        this.processoFisico.endereco.uf = this.findEstado()
        this.carregarEnderecoIterpa()
        return
      }
      this.processoFisico = this.clearProcessoFisico()
      this.processoFisico.numero = numeroProcesso
      this.carregarEnderecoIterpa()
    },

    async validateAndSaveOnFinalizar () {
      // workaround para contornar problema na validação do componente de telefone
      delete this.$refs.observer.refs['$ignoreTelefone$']
      delete this.$refs.observer.refs['$ignoreEmail$']

      this.$refs.observer.validate().then(async success => {
        if (!success) {
          this.errorNotification({message: 'Preencha todos os campos obrigatórios.'})
          return
        }
        this.finalizarCadastroProcessoFisico()
      })
    },

    async finalizarCadastroProcessoFisico () {
      try {
        this.processoFisico.isFinalizado = true
        let processoSalvar = _.cloneDeep(this.processoFisico)
        this.formataProcessoSalvar(processoSalvar)
        await this.salvarProcessoFisico(processoSalvar)

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Cadastro finalizado com sucesso!'
        )

        this.$router.push({
          name: 'cof/home'
        })
      } catch (error) {
        this.errorNotification(error)

        throw error
      }
    },

    async salvarCadastroProcessoFisico () {
      try {
        this.processoFisico.isFinalizado = false
        let processoSalvar = _.cloneDeep(this.processoFisico)
        this.formataProcessoSalvar(processoSalvar)
        const resp = await this.salvarProcessoFisico(processoSalvar)
        this.completeForms(resp, resp.numero)
        this.successNotification()
      } catch (error) {
        this.errorNotification(error)
        throw error
      } finally {
        this.formataProcesso()
      }
    },

    formataProcessoSalvar (processoSalvar) {
      if (!processoSalvar.endereco.municipio.id) {
        processoSalvar.endereco.municipio = null
      }
      if (!processoSalvar.cadastrante.endereco.municipio.id) {
        processoSalvar.cadastrante.endereco.municipio = null
      }
      if (!processoSalvar.conjuge.orgaoExpedidor.codigo) {
        processoSalvar.conjuge.orgaoExpedidor = null
      }
      if (!processoSalvar.conjuge.municipioNaturalidade.id) {
        processoSalvar.conjuge.municipioNaturalidade = null
      }
      if (!this.processoFisico.estadoCivilInteressado) {
        processoSalvar.estadoCivilInteressado = null
        processoSalvar.conjuge = null
      }
      if (['DIVORCIADO', 'SEPARADO', 'SOLTEIRO'].includes(processoSalvar.estadoCivilInteressado)) {
        processoSalvar.conjuge = null
      }
      // Formata telefones
      processoSalvar.cadastrante.telefone = processoSalvar.cadastrante.telefone &&
        processoSalvar.cadastrante.telefone.length
        ? processoSalvar.cadastrante.telefone.join()
        : null

      processoSalvar.telefone = processoSalvar.telefone &&
        processoSalvar.telefone.length
        ? processoSalvar.telefone.join()
        : ''
      // Formata e-mails
      processoSalvar.cadastrante.email = processoSalvar.cadastrante.email &&
        processoSalvar.cadastrante.email.length
        ? processoSalvar.cadastrante.email.join()
        : null

      processoSalvar.email = processoSalvar.email &&
        processoSalvar.email.length
        ? processoSalvar.email.join()
        : ''
    },

    formataProcesso () {
      if (!this.processoFisico.endereco.municipio) {
        this.processoFisico.endereco.municipio = {id: null}
      }
      if (!this.processoFisico.cadastrante.endereco.municipio) {
        this.processoFisico.cadastrante.endereco.municipio = {id: null}
      }
      if (!this.processoFisico.conjuge) {
        this.clearConjuge()
      }
      if (!this.processoFisico.conjuge.orgaoExpedidor) {
        this.processoFisico.conjuge.orgaoExpedidor = {
          id: '',
          codigo: '',
          nome: '',
          estado: '',
          nomeEstado: ''
        }
      }
      if (!this.processoFisico.conjuge.municipioNaturalidade) {
        this.clearMunicipioNaturalidade()
      }
      // Formata telefones
      this.processoFisico.cadastrante.telefone = this.processoFisico.cadastrante.telefone &&
        this.processoFisico.cadastrante.telefone.length
        ? this.processoFisico.cadastrante.telefone.split(',') : []

      this.processoFisico.telefone = this.processoFisico.telefone &&
        this.processoFisico.telefone.length
        ? this.processoFisico.telefone.split(',') : []
      // Formata e-mails
      this.processoFisico.cadastrante.email = this.processoFisico.cadastrante.email &&
        this.processoFisico.cadastrante.email.length
        ? this.processoFisico.cadastrante.email.split(',') : []

      this.processoFisico.email = this.processoFisico.email &&
        this.processoFisico.email.length
        ? this.processoFisico.email.split(',') : []
    },

    onSemNumeroCheck (checked) {
      if (checked) {
        this.processoFisico.endereco.numero = 0
        return
      }

      this.processoFisico.endereco.numero = null
    },

    onSemNumeroCadastranteCheck (checked) {
      if (checked) {
        this.processoFisico.cadastrante.endereco.numero = 0
        return
      }

      this.processoFisico.cadastrante.endereco.numero = null
    },

    successNotification () {
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.DADOS_SALVOS_SUCESSO
      )
    },

    errorNotification (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )
    },

    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => { this.$router.push({ name: 'cof/home' }) },
        () => {},
        'Sim',
        'Não'
      )
    },

    voltar () {
      if (this.isActive === 'interessado') {
        this.isActive = 'cadastrante'
      } else {
        this.isActive = 'geral'
      }
    },

    async proximo () {
      await this.salvar()
      if (this.isActive === 'geral') {
        this.isActive = 'cadastrante'
      } else {
        this.isActive = 'interessado'
      }
    },

    async salvar () {
      await this.salvarCadastroProcessoFisico()
    }
  }
}
</script>

<style>
.card-header {
  margin-bottom: 20px;
}

.select {
  width:100%
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

.container-cadastro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-icon-search {
  color: #009f61;
}

span /deep/ .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/processoFisico/para/CadastroProcessoFisicoPa.vue